/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientIdentity
 */
export interface ClientIdentity {
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientIdentity
     */
    companyLegalName?: string;
    /**
     * 
     * @type {PostalAddress}
     * @memberof ClientIdentity
     */
    address?: PostalAddress;
}

/**
 * Check if a given object implements the ClientIdentity interface.
 */
export function instanceOfClientIdentity(value: object): value is ClientIdentity {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function ClientIdentityFromJSON(json: any): ClientIdentity {
    return ClientIdentityFromJSONTyped(json, false);
}

export function ClientIdentityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientIdentity {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'companyName': json['companyName'],
        'companyLegalName': json['companyLegalName'] == null ? undefined : json['companyLegalName'],
        'address': json['address'] == null ? undefined : PostalAddressFromJSON(json['address']),
    };
}

export function ClientIdentityToJSON(value?: ClientIdentity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'companyName': value['companyName'],
        'companyLegalName': value['companyLegalName'],
        'address': PostalAddressToJSON(value['address']),
    };
}

